import { SCENE_STATES, SCROLL_STATES } from "../data/sceneStates.js";

export class Controls {
  constructor({ bridge, stateMachine }) {
    this.bridge = bridge;
    this.stateMachine = stateMachine;

    this.wheelLocked = false;
    this.touchStartY = null;

    this.onWheel = this.onWheel.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);

    window.addEventListener("wheel", this.onWheel, { passive: true });
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("touchstart", this.onTouchStart, { passive: true });
    window.addEventListener("touchend", this.onTouchEnd, { passive: true });
  }

  getCurrentScrollableState() {
    const current = this.stateMachine.currentState;
    if (SCROLL_STATES.includes(current)) {
      return current;
    }
    if (current === SCENE_STATES.PROJECT_DETAIL) {
      return SCENE_STATES.PROJECTS;
    }
    return null;
  }

  step(forward = true) {
    const current = this.getCurrentScrollableState();
    if (!current) {
      return;
    }

    const index = SCROLL_STATES.indexOf(current);
    const nextIndex = forward ? Math.min(index + 1, SCROLL_STATES.length - 1) : Math.max(index - 1, 0);

    if (nextIndex !== index) {
      this.bridge.emit("NAVIGATE", { state: SCROLL_STATES[nextIndex] });
    }
  }

  lockWheel() {
    this.wheelLocked = true;
    window.setTimeout(() => {
      this.wheelLocked = false;
    }, 460);
  }

  onWheel(event) {
    if (this.wheelLocked) {
      return;
    }

    if (Math.abs(event.deltaY) < 20) {
      return;
    }

    if (this.stateMachine.currentState === SCENE_STATES.LEGAL) {
      return;
    }

    this.lockWheel();
    this.step(event.deltaY > 0);
  }

  onKeyDown(event) {
    if (["ArrowDown", "PageDown"].includes(event.key)) {
      this.step(true);
    }

    if (["ArrowUp", "PageUp"].includes(event.key)) {
      this.step(false);
    }

    if (event.key === "Escape" && this.stateMachine.currentState === SCENE_STATES.PROJECT_DETAIL) {
      this.bridge.emit("CLOSE_PROJECT", {});
    }
  }

  onTouchStart(event) {
    this.touchStartY = event.changedTouches?.[0]?.clientY ?? null;
  }

  onTouchEnd(event) {
    if (this.touchStartY === null) {
      return;
    }

    const touchEnd = event.changedTouches?.[0]?.clientY;
    const deltaY = this.touchStartY - touchEnd;

    if (Math.abs(deltaY) > 30) {
      this.step(deltaY > 0);
    }

    this.touchStartY = null;
  }

  destroy() {
    window.removeEventListener("wheel", this.onWheel);
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("touchstart", this.onTouchStart);
    window.removeEventListener("touchend", this.onTouchEnd);
  }
}
